import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/modules/authentication'
import res from '@/modules/reservas'
import client from '@/modules/clientes'
import emp from '@/modules/empleados'
import mat from '@/modules/materiales'
import prov from '@/modules/proveedores'
import act from '@/modules/actividades'
import tar from '@/modules/tarifas'

//import VuexPersistence from 'vuex-persist'


Vue.use(Vuex)

/*const vuexLocal = new VuexPersistence({
  storage: localStorage,
  modules: ['auth']
})*/

export default new Vuex.Store({
  state: {
    loading: false,
    colorBase: '#ffffff',
    colorBoton: '#00695C',//'#eb991c'//'#92d2c4',
    colorBotonRed: '#E57373',
    colorBotonBlue: '#64B5F6'
   
                  
  },
  mutations: {
    setLoading (state, bool){
      state.loading = bool
    }
  },
  actions: {
  },
  modules: {
    auth, res, client, emp, mat, prov, act, tar
  },

 // plugins: [vuexLocal.plugin]
})
